import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import { ComponentInterface } from '../../../fc-core/src/component-interface';
import { componentFactory, getMouseCoordinate } from '../../../fc-core/src/lib';
var inclusionList = {
  candlestick: !0
};

var manageMultiCanvasCrossline =
/*#__PURE__*/
function (_ComponentInterface) {
  _inherits(manageMultiCanvasCrossline, _ComponentInterface);

  function manageMultiCanvasCrossline() {
    var _this;

    _classCallCheck(this, manageMultiCanvasCrossline);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(manageMultiCanvasCrossline).call(this)), _this._handlers = function (a) {
      return {
        onhover: function onhover(b) {
          b.originalEvent && a.show(b);
        },
        onhoverout: function onhoverout(b) {
          b.originalEvent && a.hide(b);
        }
      };
    }(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(manageMultiCanvasCrossline, [{
    key: "getAxesInfo",
    value: function getAxesInfo() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var b = arguments.length > 1 ? arguments[1] : undefined;
      var c,
          d,
          e,
          f,
          g = this,
          h = b.getAxes(),
          j = [],
          k = getMouseCoordinate(g.getFromEnv('chart-container'), a.originalEvent, g.getFromEnv('chart')),
          l = k.chartX || 0,
          m = k.chartY || 0;

      for (c = h.length - 1; 0 <= c; c--) {
        d = h[c].axis, e = h[c].isY, f = !!d.config.isVertical, j.push({
          value: f ? d.getValue(m) : d.getValue(l),
          axis: d,
          isVertical: f,
          isY: e
        });
      }

      return j;
    }
  }, {
    key: "getName",
    value: function getName() {
      return 'multiCanvasCrosslineManager';
    }
  }, {
    key: "getType",
    value: function getType() {
      return 'multiCanvasCrosslineManager';
    }
  }, {
    key: "show",
    value: function show(a) {
      var b,
          c = a.sender,
          d = this.getFromEnv('chart');
      b = this.getAxesInfo(a, c), d.iterateComponents(function (a) {
        'canvas' === a.getName() && a !== c && a.fireEvent('fc-mousemove', {
          axes: b
        });
      });
    }
  }, {
    key: "hide",
    value: function hide(a) {
      var b = a.sender,
          c = getMouseCoordinate(b.getFromEnv('chart-container'), a && a.originalEvent, b.getFromEnv('chart')),
          d = c.chartX,
          e = c.chartY;
      b.isWithinCanvas(d, e) || this.getFromEnv('chart').iterateComponents(function (a) {
        'canvas' === a.getName() && a !== b && a.fireEvent('fc-mouseout');
      });
    }
  }]);

  return manageMultiCanvasCrossline;
}(ComponentInterface);

export default {
  extension: function extension(a) {
    a.addEventListener('instantiated', function (a) {
      if (a.sender.getType && 'chartAPI' === a.sender.getType() && inclusionList[a.sender.getName && a.sender.getName()]) {
        var b,
            c,
            d = a.sender;
        d.registerFactory('multiCanvasCrossline', function () {
          componentFactory(d, manageMultiCanvasCrossline, 'multiCanvasCrosslineManager'), b = d.getChildren('multiCanvasCrosslineManager')[0], c = b._handlers, d.iterateComponents(function (a) {
            'canvas' === a.getName() && (a.addEventListener('fc-mouseover', c.onhover), a.addEventListener('fc-mousemove', c.onhover), a.addEventListener('fc-mouseout', c.onhoverout));
          });
        }, ['canvas']);
      }
    });
  },
  name: 'multi-canvas-crossline-manager',
  type: 'extension',
  requiresFusionCharts: !0
};